import { render, staticRenderFns } from "./decision-maker.vue?vue&type=template&id=5d7ef776"
import script from "./decision-maker.vue?vue&type=script&lang=js"
export * from "./decision-maker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports